<template>
  <div class="content-loader-top">
    <pulse-loader :loading="this.loading" :color="this.color" :size="this.size"></pulse-loader>
  </div>
</template>

<script>
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {
    components: {
      PulseLoader,
    },
    data () {
      return {
        loading: true,
        size: "16px",
        color: "#03758B",
      }
    },
  };
</script>
<style lang="scss" scoped>

.content-loader-top {
  width: 100%;  
  height: 100%;  
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
}
</style>;